import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';

let CD;

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    methods: {
        async onExport() {
            const wb = MyXLSX2.createBook();
            this.isLoadingExport = true;

            try {
                const details = await this.getExportData({
                    ...this.OrderParam,
                    ...this.prevQuery,
                });

                const payoutSheet = this.getSheet(details, '支出');
                const incomeSheet = this.getSheet(details, '收入');

                if (payoutSheet) MyXLSX2.bookAppendSheet(wb, payoutSheet, '支出');
                if (incomeSheet) MyXLSX2.bookAppendSheet(wb, incomeSheet, '收入');

                MyXLSX2.download(wb, `財務收支${CD}`);
            } catch (e) {
                this.$message({
                    showClose: true,
                    message: '無資料可匯出',
                    type: 'error',
                });
            } finally {
                this.isLoadingExport = false;
            }
        },

        getSheet(oriDetails, subTitle) {
            const FLG = subTitle === '支出' ? -1 : 1;
            const details = _.filter(oriDetails, ['flg', FLG]);
            const counterDetails = _.filter(oriDetails, ['flg', -FLG]);
            if (!details.length) return null;
            const title = `財務收支 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '編號', align: 'center' },
                { text: '類型', align: 'center' },
                { text: '繳費/收款日期', align: 'center' },
                { text: '摘要', width: 75, align: 'left' },
                { text: '收支項目', width: 60, align: 'left' },
                { text: '金額', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                { text: '匯率', width: 8, align: 'right' },
                { text: '約當台幣', align: 'right', number: true },
                { text: '備註', width: 120, align: 'left' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.moo,
                    this.getTypeName(item),
                    item.paY_DAT ? moment(item.paY_DAT).format('YYYY-MM-DD') : '--',
                    item.tpc,
                    this.getHierarchyItemName(item.iteM_SNO, item.iteM_NAM),
                    item.amt,
                    item.cny,
                    item.rat,
                    item.amt * item.rat,
                    item.transferSystemNo ? `同存款帳戶互轉 ${item.transferSystemNo}： ${item.transferNote}` || '' : item.mem || '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * o.rat);
            const counterTotalAmt = _.sumBy(counterDetails, (o) => o.amt * o.rat);
            const totalNetAmt = FLG > 0 ? totalAmt - counterTotalAmt : counterTotalAmt - totalAmt;
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', '', totalAmt, '']);

            // 表頭資訊
            const headRows = [
                ...this.getQueryText(),
                { label: '金額總計(約當台幣)', value: totalAmt },
                { label: '淨額(約當台幣)', value: totalNetAmt },
                ...this.getTrimCnyStatistic(details),
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getTypeName(item) {
            if (!item.type) return item.flg === -1 ? '支出' : '收入';

            if (item.type === 1) return '營業其他收入';
            if (item.type === 2) return '營業其他支出';
            if (item.type === 5) return '財務資產收入';
            if (item.type === 6) return '財務資產支出';
            return null;
        },

        async getExportData(params) {
            const PageSize = 1000;
            let PageNum = 1;
            const { query, resetQuery } = this.getManualQuery(this.prevQuery);
            const url = `VariableStatementSettingPage/GetList${query}`;

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: {
                    ...params,
                    ...resetQuery,
                    PageNum: 1,
                    PageSize,
                },
            });

            console.log(data);

            // 足夠的PageSize
            if (PageSize > data.totalNum) {
                return data.items;
            }

            const currentList = [...data.items];
            for (let i = 0; i < Math.ceil(data.totalNum / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: { ...params, PageNum, PageSize },
                });
                currentList.push(...resp.data.items);
            }
            return currentList;
        },

        getQueryText() {
            const LIST = [
                { text: '日期', field: 'queryDate', isDate: true },
                { text: '關鍵字', field: 'MOO_TPC' },
                { text: '金額下限', field: 'MinAmt' },
                { text: '金額上限', field: 'MaxAmt' },
                { text: '收支項目', field: 'itemSnos', textOnly: true },
                { text: '幣別', field: 'cnyList' },
                {
                    text: '銀行帳戶',
                    field: 'bankSnos',
                    options: this.bankAccountOptions,
                    optionFind: 'sno',
                    optionField: 'tpc',
                },
            ];
            const RETURN = [];

            LIST.forEach((item) => {
                const VALUE = this.prevQuery[item.field];
                if ((!Array.isArray(VALUE) && VALUE) || (Array.isArray(VALUE) && VALUE.length)) {
                    const OPTIONS = item.options;
                    if (item.textOnly) {
                        RETURN.push({
                            label: item.text,
                            value: `${VALUE.length === 1 ? '單選' : `複選(${VALUE.length})`}`,
                        });
                    } else if (Array.isArray(VALUE)) {
                        if (item.isDate) {
                            const sd = moment(VALUE[0]).format('YYYY-MM-DD');
                            const ed = moment(VALUE[1]).format('YYYY-MM-DD');
                            RETURN.push({
                                label: item.text,
                                value: `${sd} ~ ${ed}`,
                            });
                        } else if (OPTIONS) {
                            const LIST_TEXT = _.map(VALUE, (o) => _.find(OPTIONS, [item.optionFind, o])[item.optionField]);
                            RETURN.push({
                                label: item.text,
                                value: LIST_TEXT.join(', '),
                            });
                        } else {
                            RETURN.push({
                                label: item.text,
                                value: VALUE.join(', '),
                            });
                        }
                    } else if (OPTIONS) {
                        const FOUND = _.find(OPTIONS, [item.optionFind, VALUE])[item.optionField];
                        RETURN.push({ label: item.text, value: FOUND });
                    } else {
                        RETURN.push({
                            label: item.text,
                            value: VALUE,
                        });
                    }
                }
            });

            return RETURN.length ? RETURN : [{ label: '查詢條件', value: '不限' }];
        },
        getTrimCnyStatistic(details) {
            const cnyOptions = this.$store.getters['cny/cnyOptions'];
            const cnyStatisticList = [];
            cnyOptions.forEach((item, i) => {
                const amt = _.chain(details)
                    .filter(['cny', item.cny])
                    .sumBy('amt')
                    .value();
                if (amt) {
                    cnyStatisticList.push({
                        cny: item.cny,
                        label: !i ? '各幣別總額' : '',
                        value: `${item.cny}: ${amt.toLocaleString('en-US')}`,
                    });
                }
            });
            if (cnyStatisticList.length === 1 && _.first(cnyStatisticList).cny === 'TWD') return [];
            return cnyStatisticList;
        },
        /**
         * 根據收支項目的 SNO 組合出三階層名稱（例如：營業支出 / 營業費用 / 租金支出）
         * @param {Number} itemSno 收支項目編號
         * @param {String} fallbackName 備用名稱（未對應到時使用）
         * @returns {String} 三階層名稱
         */
        getHierarchyItemName(itemSno, fallbackName) {
            if (!itemSno) return fallbackName || '--';
            const statementOptionsForUi = this.$store.getters['statement/statementUiOptions'];
            if (!statementOptionsForUi) return fallbackName || '--';

            const hierarchy = [null, null, null];
            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            let found = false;
            for (let t = 0; t < types.length; t += 1) {
                const options = statementOptionsForUi[types[t].key];
                if (!options) continue;
                for (let i = 0; i < options.length; i += 1) {
                    const lv1Item = options[i];
                    if (!lv1Item.childSettings) continue;
                    for (let j = 0; j < lv1Item.childSettings.length; j += 1) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemSno) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            found = true;
                            break;
                        }
                    }
                    if (found) break;
                }
                if (found) break;
            }

            if (!found) return fallbackName || '--';
            return hierarchy.join(' / ');
        },
    },
};
